module.exports = "<div class=\"being-offered-example-popover\"><img class=\"example-picture\" src=\"/origami/images/example-whatyouget-image.png\"/></div>";